/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ t: NonNullable<unknown> }} Auto_Mode_ValueInputs */



/**
* | output |
* | --- |
* | "Auto mode (+/-{t}°C)" |
*
* @param {Auto_Mode_ValueInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const auto_mode_value = /** @type {((inputs: Auto_Mode_ValueInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auto_Mode_ValueInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Auto mode (+/-${i?.t}°C)`)
	return /** @type {LocalizedString} */ (`Mode auto (+/-${i?.t}°C)`)
});